import l from "dayjs";
import { DaymapQuery as d } from "../daymapQuery.js";
var u;
((a) => {
  class c extends d {
    constructor(t) {
      super(
        ["studentnotes", t.studentId, t.from, t.to, t.categoryId, t.loadAttachments, t.classId],
        t,
        `/lms/api/students/notes/student?studentId=${t.studentId}&from=${l(t.from).format("YYYY-MM-DD")}&to=${l(t.to).format("YYYY-MM-DD")}&categoryId=${t.categoryId ?? ""}&loadAttachments=${t.loadAttachments ?? !1}&classId=${t.classId ?? ""}`,
        null,
        { enabled: t.enabled !== !1 }
      );
    }
  }
  a.StudentNotes = c;
  class o extends d {
    constructor() {
      super(
        ["notecategories"],
        null,
        "/lms/api/students/notes/categories",
        null
      );
    }
  }
  a.StudentNoteCategories = o;
  class r extends d {
    constructor(t) {
      super(
        ["notesforevent", t.eventId, t.studentId, t.loadAttachments],
        t,
        `/lms/api/students/notes/student/${t.studentId}/event/${t.eventId}?loadAttachments=${t.loadAttachments ?? !1}`,
        null,
        { select: (n) => n.map((e) => ({
          ...e,
          NoteDate: new Date(e.NoteDate),
          Expiry: e.Expiry ? new Date(e.Expiry) : null,
          Updated: e.Updated ? new Date(e.Updated) : null
        })), enabled: t.eventId > 0 && t.studentId > 0 }
      );
    }
  }
  a.NotesForEvent = r;
  class m extends d {
    constructor(t) {
      super(
        ["notesforclass", t.classId, t.studentId, t.loadAttachments],
        t,
        `/lms/api/students/notes/student/${t.studentId}/class/${t.classId}?loadAttachments=${t.loadAttachments ?? !1}`,
        null,
        { select: (n) => n.map((e) => ({
          ...e,
          NoteDate: new Date(e.NoteDate),
          Expiry: e.Expiry ? new Date(e.Expiry) : null,
          Updated: e.Updated ? new Date(e.Updated) : null
        })), enabled: t.classId > 0 && t.studentId > 0 }
      );
    }
  }
  a.NotesForClass = m;
  class i extends d {
    constructor() {
      super(
        ["getstudentnotediarycategory"],
        null,
        "/lms/api/students/notes/categories/studentdiary",
        null
      );
    }
  }
  a.GetStudentNoteDiaryCategory = i;
})(u || (u = {}));
export {
  u as notes
};
//# sourceMappingURL=index.js.map
